<template>
	<div class="process head-label">
		<img class="process_img" src="../../static/home/bg.png" alt="" />
		<div class="process_con">
			<p class="f36">借款流程</p>
			<p class="f14 red">LOAN PROCESS</p>
			<div class="process_arr">
				<div class="process_item" v-for="(item, i) in processArr" :key="i">
					<img class="img_icon" :src="item.img" alt="" />
					<p class="f24">{{ item.title }}</p>
					<span class="f12">{{ item.name }}</span>
				</div>
				<div class="line"></div>
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		data () {
			return {
				processArr: [{
						img: require('../../static/home/1.png'),
						title: "申请",
						name: '添加客服微信'
					},
					{
						img: require('../../static/home/2.png'),
						title: "评估",
						name: '提交物品详情'
					},
					{
						img: require('../../static/home/3.png'),
						title: "审核",
						name: '即时审批额度'
					},
					{
						img: require('../../static/home/4.png'),
						title: "放款",
						name: '借款迅速到账'
					},
				],
			}
		}
	}
</script>

<style>
</style>


// WEBPACK FOOTER //
// src/components/Process.vue